import { combineReducers } from 'redux';
import { createReducer } from '../helpers/reduxHelpers';
import { createReducer as createReducerOrig, PayloadAction } from '@reduxjs/toolkit';
import * as Actions from '../actions/types';
import { WorkspaceInterface } from '../interfaces/WorkspaceInterface';

const setWorkspaceLoaderReducer = createReducer({
  initialState: false,
  actionType: Actions.SET_WORKSPACE_LOADER
});

const initialStateCurrentWorkspace = {} as WorkspaceInterface;

const setCurrentWorkspaceReducer = createReducerOrig(initialStateCurrentWorkspace, (builder) => {
  builder.addCase(
    Actions.SET_CURRENT_WORKSPACE,
    (state = initialStateCurrentWorkspace, action: PayloadAction<any, never>) => {
      return { ...(action.payload || {}) };
    }
  );
});

const workspaceReducer = combineReducers({
  loading: setWorkspaceLoaderReducer,
  workspace: setCurrentWorkspaceReducer
});

export default workspaceReducer;
